// Libs
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

// Components & Utils
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading } from "../utils/Actions";

export default function MealPlans(props) {
  // State
  const [, dispatch] = useGlobalValue();
  const [selectedMealComments, setMealComments] = useState("");
  const [meals, setMeals] = useState([]);
  const addComments = (key) => {
    setIsLoading(true, dispatch);
    let _meals = meals;
    _meals[key].comments = selectedMealComments;
    setMeals(_meals);
    setIsLoading(false, dispatch);
  };
  return (
    <Modal show={props.show}>
      <Modal.Header>
        <Modal.Title>Add Comments to {props.meal_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <textarea className="form-control" onChange={e => setMealComments(e.target.value)}>
      </textarea>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.hide}>Cancel</Button>
        <Button variant="success" onClick={() => addComments(props.meal.meal_id)}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
